import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f7a694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Default',
  props: {
  isBackgroundTransparent: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;



const backgroundClass = computed(() => {
  if (props.isBackgroundTransparent) {
    return "bg-transparent";
  }

  return "bg-background";
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-column min-vh-100 main-container", backgroundClass.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterView)
    ])
  ], 2))
}
}

})